import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { CreateNewBusinessComponent } from "src/app/shared/components/create-new-business/create-new-business.component";
import { UploadBusinessImageComponent } from "src/app/shared/components/upload-business-image/upload-business-image.component";
import { ViewMediaGalleryComponent } from "src/app/shared/components/view-media-gallery/view-media-gallery.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { MessagingService } from "src/app/providers/messaging.service";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { NavigationService } from "src/app/providers/navigation.service";
import { ApiService } from "src/app/providers/api.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { LinkQRComponent } from "../businesses/link-qr/link-qr.component";

@Component({
  selector: 'sm-employee-invitation-details',
  templateUrl: './employee-invitation-details.component.html',
  styleUrls: ['./employee-invitation-details.component.scss']
})
export class EmployeeInvitationDetailsComponent implements OnInit,OnDestroy {
  iter1: boolean = false;
  iter2: boolean = false;

  entityHashId: string = "";
  employeeHashId: string = "";
  homeQRCode: any = "";
  shopQRCode: any = "";
  _entityDetails: any[] = [];
  employeeData: any = []
  appFunctionality: any = []
  public loader: boolean = false;
  private _apiSubscription: Subscription  = new Subscription();;
  // clickEventSubscription: Subscription;
  constructor(
    private _navService: NavigationService,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    private dialog: MatDialog,
    private router: Router,
    private loaderService: LoaderServiceService,
    private _modelRef: MatDialog,
    private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging,
  ) {
    this._navService.hideSidebarAndNav = false;
    

    


      this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
        
        if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_EMPLOYEE_REQUEST_LIST){
          console.log(resData);
          this.employeeData = []
          if(resData.result){
            resData.result.forEach((element:any) => {
              
                if(element.requestHashId == this.employeeHashId){
  
                  this.employeeData.push(element)
                }
            });
          }
          console.log(this.employeeData)
          
        }
        if(resData.responseType ===  SM_CONSTANTS.RESULT_API_ADD_AS_EMPLOYEE){
          if(resData.result){
            const queryParams = { entityHash: this.route.snapshot.queryParams.entityHash };
            this.router.navigate(['../'], { queryParams, relativeTo: this.route });
          }
        }
        this.loaderService.showLoader = false
        this.loader = false;
      });
      if(!localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == 'null'){
        this.messagingService.requestPermission();
      }

  }

  linkQR(bookingType: any) {
    this._entityDetails[0].qrBookingtype = bookingType;
    let dialogRef = this.dialog.open(LinkQRComponent, {
      width: "500px",
      disableClose: true,
      data: {
        ref: this.dialog,
        data: this._entityDetails,
      },
    });
  }

  unlinkQR(bookingType: any) {
    console.log("fired unlink");
    if (confirm("Do you want to link this QR code?")) {
      let data = {
        businessHashId: this._entityDetails[0].hashId,
        code: bookingType == 0 ? this.homeQRCode : this.shopQRCode,
      };
      this.loader = true;
      this._apiService.unlinkQRCode(data);

      // setTimeout(() => {
      //   this.ngOnInit()
      // }, 2000);
    }
  }

  deleteBusiness() {
    // if (
    //   confirm(
    //     "Are you sure you want to delete " +
    //       this._entityDetails[0].entityName +
    //       " entity?"
    //   )
    // ) {
    //   let data = {
    //     entityInfo: {
    //       hashId: this._entityDetails[0].hashId,
    //       isDelete: 1,
    //     },
    //   };

    //   this._apiService.deleteBusiness(data);
    // }

    const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
      data : {
        title : 'Alert',
        message : 'Are you sure you want to delete ' +
        this._entityDetails[0].entityName +
        ' entity?',
        okbtn : 'Confirm',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
      },
      disableClose : true
    });
    dialogRef.afterClosed().subscribe(result=>{
      console.log(result);
      if(result){ 
        let data = {
          entityInfo: {
            hashId: this._entityDetails[0].hashId,
            isDelete: 1,
          },
        };
  
        this._apiService.deleteBusiness(data);
      }
    })
  }

  shareBusiness(){
    window.open(this._entityDetails[0].webUrl, '_blank');
  }

  ngOnInit(): void {
   

      
      this.route.queryParams.subscribe((data) => {
        console.log(data.entityHash);
        this.entityHashId = data.entityHash;
        this.employeeHashId = data.requestHashId;
      });
      this.loader = true;
      this.loaderService.showLoader = true;
      this._apiService.getEmployeeRequestList(this.entityHashId);
      // this._apiService.getFunctionalityByEntityId(this.entityHashId)
      // this._apiService.getEntityDetails(this.entityHashId);
   
    // this._apiService.getBookingQRCodes(this.entityHashId)

    // GET_ENTITY_DETAILS_RESULT

   
  }
  cancelOffer(){

    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
      data : {
        title : 'Alert',
        message : 'Are you sure you want to cancel this job offer?',
        okbtn : 'Confirm',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
      },
      disableClose : true
    });
    dialogRef.afterClosed().subscribe(result=>{
      console.log(result);
      if(result){ 
        let data = {
          isAccept: 3
        }
        this.loaderService.showLoader = true
        this._apiService.addAsEmployee(this.employeeData[0].requestHashId,data)
       
    
       
      }
    })
  

  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    // this.clickEventSubscription.unsubscribe();
  }

  openBookings(type: string) {

    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'On-Shop Bookings')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "bookings"], {
        queryParams: {
          entityHash: this._entityDetails[0].hashId,
          bookingType: type,
        },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "bookings"], {
          queryParams: {
            entityHash: this._entityDetails[0].hashId,
            bookingType: type,
          },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Ok',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
          },
          disableClose : true
        });
      }
    }


    
  }

  openTaxAndGST() {
    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Tax and GST')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "tax-and-gst"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "tax-and-gst"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        // alert('This is a premium functionality and you need to purchase a paid pack for using it.')
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Ok',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
          },
          disableClose : true
        });
        // dialogRef.afterClosed().subscribe(result=>{
        //   console.log(result);
        //   if(result){

        //   }
        // })
      }
    }
    
   
  }
  openDiscount() {
    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Discounts')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "discount"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "discount"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Ok',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
          },
          disableClose : true
        });
      }
    }
  }
  openOnlinePayments() {
    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Online payment')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "online-payments"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "online-payments"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Ok',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
          },
          disableClose : true
        });
      }
    }
    
  }
  openDocuments(){
    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Documents')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "documents"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "documents"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Ok',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
          },
          disableClose : true
        });
      }
    }
  }
  openBookingHistory() {
    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Booking history')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "booking-history"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "booking-history"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Ok',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
          },
          disableClose : true
        });
      }
    }

  }

  editBusiness() {
    this._modelRef.open(CreateNewBusinessComponent, {
      width: "500px",
      data: {
        title: "Edit Business",
        ref: this._modelRef,
        data: this._entityDetails,
      },
    });
  }
  uploadMedia() {
    this._modelRef.open(UploadBusinessImageComponent, {
      width: "500px",
      data: {
        title: "Upload Media",
        ref: this._modelRef,
        data: this._entityDetails[0],
      },
    });
  }

  openServices() {

    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Services & charges')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "services"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "services"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Ok',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
          },
          disableClose : true
        });
      }
    }
    
  }
  openFeedback() {

    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Feedback')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "feedback"], {
        queryParams: { entityHash: this._entityDetails[0].hashId , entityName: this._entityDetails[0].entityName},
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "feedback"], {
          queryParams: { entityHash: this._entityDetails[0].hashId , entityName: this._entityDetails[0].entityName},
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Ok',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
          },
          disableClose : true
        });
      }
    }

    
  }
  openQRCode() {

    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'QR Code')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "qr-code"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "qr-code"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Ok',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
          },
          disableClose : true
        });
      }
    }



    
  }
  openPlanAndRenew() {

    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Current plan & renew')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "plan-and-renew"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "plan-and-renew"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Ok',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
          },
          disableClose : true
        });
      }
    }


   
  }

  viewMedia() {
    if (
      this._entityDetails[0].assetInfo &&
      this._entityDetails[0].assetInfo != null &&
      this._entityDetails[0].assetInfo != "null"
    ) {
      this.dialog.open(ViewMediaGalleryComponent, {
        width: "1200px",
        data: {
          title: "Media gallery",
          ref: this.dialog,
          data: JSON.parse(this._entityDetails[0].assetInfo),
          entityHash: this._entityDetails[0].hashId
        },
      });
    } else {
      this.dialog.open(ViewMediaGalleryComponent, {
        width: "500px",
        data: {
          title: "Media gallery",
          ref: this.dialog,
          data: [],
        },
      });
    }
  }
  toShowCheckHome: number = 1;
  toShowCheckShop: number = 1;
  onToggleChange(event: any, serviceType: any) {
    if (event.checked) {
      if (serviceType == 0) {
        this.toShowCheckHome = 1;
        let data = {
          entityInfo: {
            hashId: this._entityDetails[0].hashId,
            homeServiceStatus: 1,
            entityStatus: 1
          },
        };
        this.loaderService.showLoader = true;
        this._apiService.updateEntityInfo(data);
      } else if (serviceType == 1) {
        this.toShowCheckShop = 1;
        let data = {
          entityInfo: {
            hashId: this._entityDetails[0].hashId,
            shopServiceStatus: 1,
            entityStatus: 1
          },
        };
        this.loaderService.showLoader = true;
        this._apiService.updateEntityInfo(data);
      }
    } else if (!event.checked) {
      if (serviceType == 0) {
        this.toShowCheckHome = 0;
        let data = {
          entityInfo: {
            hashId: this._entityDetails[0].hashId,
            homeServiceStatus: 0,
            entityStatus: 1
          },
        };
        this.loaderService.showLoader = true;
        this._apiService.updateEntityInfo(data);
      } else if (serviceType == 1) {
        this.toShowCheckShop = 0;
        let data = {
          entityInfo: {
            hashId: this._entityDetails[0].hashId,
            shopServiceStatus: 0,
            entityStatus: 1
          },
        };
        this.loaderService.showLoader = true;
        this._apiService.updateEntityInfo(data);
      }
    }
  }

  openServiceTimings(type:any){

    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Set Shop service timings')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "service-timings"], {
        queryParams: { serviceType: type, entityHash: this._entityDetails[0].hashId, },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "service-timings"], {
          queryParams: { serviceType: type, entityHash: this._entityDetails[0].hashId, },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Ok',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
          },
          disableClose : true
        });
      }
    }


    
  }


  openEmployees() {

    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Employees')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "employees"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "employees"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Ok',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
          },
          disableClose : true
        });
      }
    }


   
  }

  openSalary(){
    this.router.navigate(["/businesses", "details", "employees", "employee-details", "salary"], {
      queryParamsHandling: 'preserve' , 
    });
  }
  openSalarySettings(){
    this.router.navigate(["/businesses", "details", "employees", "employee-details", "salary-settings"], {
      queryParamsHandling: 'preserve' , 
    });
  }
  openCredits(){
    this.router.navigate(["/businesses", "details", "employees", "employee-details", "pay-credits"], {
      queryParamsHandling: 'preserve' , 
    });
  }
  openDutyLogs(){
    this.router.navigate(["/businesses", "details", "employees", "employee-details", "duty-logs"], {
      queryParamsHandling: 'preserve' , 
    });
  }
  openCurrentPlan(){
    this.router.navigate(["/businesses", "details", "employees", "employee-details", "current-plan"], {
      queryParamsHandling: 'preserve' , 
    });
  }

  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  test: any = "125, Raniganj By-Pass Road, Raniganj, West Bengal 713347, India"
}
